import { useQuery } from 'react-query';
import {
  getLatestPostsCount,
  type GetLatestPostsCountResponse
} from '../../services/loungeService';

export function useGetLatestPostsCount(
  postId?: string,
  categoryGroup = 'community',
  enabled = true
) {
  return useQuery<GetLatestPostsCountResponse, Error>(
    ['latestPostsCount', postId, categoryGroup],
    () => getLatestPostsCount(postId, categoryGroup),
    {
      enabled,
      refetchInterval: enabled ? 30 * 1000 : false
    }
  );
}
